module.exports = __webpack_public_path__ + "static/signal-730e3cb19ea3b43abf508d236953585e.jpg";